import styled from 'styled-components'

const getWidth = props => {
  switch (props.logosCount) {
    case 2:
      return '80px'
    case 3:
      return '250px'
    default:
      return '100%'
  }
}

const LogosView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: ${props => props.theme.ringierBanner?.logosSection?.width || getWidth(props)};
  padding-bottom: 16px;
`

export default LogosView
